import { render, staticRenderFns } from "./IllustrationBottom.vue?vue&type=template&id=b5a9b02a&"
import script from "./IllustrationBottom.vue?vue&type=script&lang=js&"
export * from "./IllustrationBottom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports